import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function KidsMartialArtsScheduleLocation() {
  return <section className="py-24 bg-off-white" data-id="element-2153">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2154">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-2155">
          <div data-id="element-2156">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2157">Class Times</h2>
            <ScheduleTable data-id="element-2158" />
          </div>
          <div data-id="element-2159">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2160">
              Taekwondo Classes in Farmington Hills, MI
            </h2>
            <LocationBlock data-id="element-2161" />
          </div>
        </div>
      </div>
    </section>;
}